import { Box, Button, Typography } from '@material-ui/core';
import AssignmentTurnedIn from '@material-ui/icons/AssignmentTurnedIn';
import Add from '@material-ui/icons/Add';
import { useStyles } from '../../../styles';
import '../../../styles/emptyProjectsState.css';
import HintCard from '../../../common/HintCard';

interface EmptyProjectsStateProps {
  isToolAdmin: boolean;
  onAddProject: () => void;
}

export const EmptyProjectsState = ({
  isToolAdmin,
  onAddProject,
}: EmptyProjectsStateProps) => {
  const classes = useStyles();

  return (
    <Box
      component="section"
      className={`eps-root ${classes.emptyProjectsStateRoot}`}
      aria-labelledby="empty-state-title"
    >
      <Box className="eps-icon-box">
        <AssignmentTurnedIn className="eps-icon-box-icon" aria-hidden="true" />
      </Box>

      <Typography id="empty-state-title" variant="h6" className="eps-title">
        No Projects yet
      </Typography>

      <Typography variant="body1" className="eps-subtitle">
        A Project connects IQE Engine to your application. It includes your app
        URL, overview description, and sign-in credentials so IQE can access,
        analyze, and test your application automatically.
      </Typography>

      <Button
        variant="contained"
        className="eps-cta-btn"
        onClick={onAddProject}
        startIcon={<Add />}
        aria-label="Add your first project"
        disabled={!isToolAdmin}
      >
        Add new Project
      </Button>

      <HintCard
        hintTitle="What happens next?"
        hintText="Once you add a Project, IQE automatically generates test scenarios
            and executes them, showing live pass/fail results."
      />
    </Box>
  );
};
